import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Direction « Le Récit » — surcharge les jetons de index.css. Importée APRÈS,
// sinon la cascade la fait perdre. Retirer cette seule ligne revient au thème
// perle/safran : aucun composant n'a été modifié pour l'appliquer.
import "@/theme-recit.css";
import App from "@/App";

// ─── Service Worker PWA : purge + register (kill-switch compris) ───
// Force la purge de TOUS les caches existants (anciens SW qui mettaient en cache /api/*)
// puis enregistre la nouvelle version propre.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // 1) Purge agressive des anciens caches (données démo fantômes)
      if (window.caches && caches.keys) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
      }

      // 2) Désinscrit tout ancien service worker (bug v1/v2)
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        // On force update pour récupérer le nouveau SW
        try { await reg.update(); } catch (_) {}
      }

      // 3) Enregistre la nouvelle version
      const registration = await navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' });

      // 4) Demande au SW actif de purger tout le cache au cas où
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_ALL_CACHES' });
      }

      // 5) Si un nouveau SW est installé, on l'active immédiatement
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
    } catch (err) {
      console.warn('SW setup error:', err);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
